/**
 * @important - typing for nuxt plugins is in index.d.ts
 */
import { useConfigStore } from '~/store/config';

export default defineNuxtPlugin(() => {
  return {
    provide: {
      lang: (langResource: string, langStr: string, opts = {} as { [name: string]: string }) => {
        const config = useConfigStore();
        if (
          config.translations &&
          config.translations[langResource] &&
          config.translations[langResource][langStr]
        ) {
          //return config.translations[langResource][langStr];
          let message = config.translations[langResource][langStr];
          if (opts) {
            Object.keys(opts).forEach(key => {
              message = message.replaceAll(`{{${key}}}`, opts[key] +'');
            });
          }
          return message;
        } else {
          console.log(`Missing translation: ${langResource} - ${langStr}`);
          return `${langResource} - ${langStr}`;
        }
      },
    },
  };
});
